@if (type === "dashboard") {
} @else {
  <footer class="py-4 fs-7 bg-black text-white">
    <div
      class="container d-lg-flex justify-content-between flex-row-reverse gap-3 text-center text-sm-start"
    >
      <div class="d-sm-flex gap-2 gap-sm-3 justify-content-center mb-3 mb-lg-0">
        <div>
          <a
            href="tel:++1 (800) 123-SCRAP"
            class="text-white text-decoration-none"
            >+1 (800) 123-SCRAP</a
          >
        </div>
        <div>
          <a
            href="mailto:info@autoscrap.com"
            class="text-white text-decoration-none"
            >info&#64;autoscrap.com</a
          >
        </div>
        <div>24/7 Customer Support</div>
      </div>
      <div class="d-sm-flex flex-row-reverse justify-content-center">
        <div class="d-flex justify-content-center gap-1">
          <span class="d-none d-sm-block">|</span>
          <a href="#" class="text-white text-decoration-none">Privacy Policy</a>
          <span>|</span>
          <a href="#" class="text-white text-decoration-none"
            >Terms of Service</a
          >
        </div>
        <div class="pe-sm-1">© 2025 AutoScrap Pro. All rights reserved.</div>
      </div>
    </div>
  </footer>
}
